import { Layout, MTools } from '@/components';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { getActivityScheduleList } from '@/services/api';
import { ISchedule } from '@/models/types/schedule';
import styles from './index.less';
import rightArrow from '@/assets/image/rightArrow.png';
import location from '@/assets/image/location.png';

interface IActivityProps {

}

const ActivitySchedule: React.FC<IActivityProps> = (props) => {
  const [data, setData] = useState<ISchedule[]>([]);
  const [current, setCurrent] = useState<number>(0);
  const [currentData, setCurrentData] = useState<ISchedule | null>(null);

  useEffect(() => {
    getData()
  }, [])
  const getData = async () => {
    const result = await getActivityScheduleList()
    if (result.success) {
      setData(result.data || []);
      setCurrentData((result.data || [])[0] || null);
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  const handleDateClick = (_idx: number) => {
    setCurrent(_idx);
    setCurrentData(data[_idx]);
  }

  const handleViewDetail = (_data: any) => {
    if (_data.bbsId) {
      MTools.Url.gotoUrl(`/app/ForumDetail/${_data.bbsId}`);
    } else if (_data.href) {
      window.open(_data.href);
    }
  }

  let _currentList = [];
  if (currentData && currentData.contentPc) {
    try {
      _currentList = JSON.parse(currentData.contentPc);
    } catch (error) {
      _currentList = [];
    }
  }

  return (
    <div className={styles.index}>
      <Layout
        padding={20}
      >
        <div className={styles.content}>
          <div className={styles.dateList}>
            <div className={styles.dateListInner}>
              {
                data.map((i: ISchedule, _idx: number) => (
                  <div
                    key={i.id}
                    className={classnames(styles.dateItem, current === _idx ? styles.active : null)}
                    onClick={() => handleDateClick(_idx)}
                  >
                    {i.feature || moment(i.activityDate).format('M月D日')}
                  </div>
                ))
              }
            </div>
          </div>

          <div className={styles.list}>
            {
              _currentList.map((i: any, _idx: number) => (
                <div className={styles.listItem} key={i?.data?.id}>
                  <div className={styles.listL}>{i?.data?.startTime}</div>
                  <div className={styles.listLine}>
                    <div className={styles.circel1}>
                      <div className={styles.circel2}>
                        <div className={styles.circel3}></div>
                      </div>
                    </div>
                    {
                      _idx < _currentList.length - 1 ? (
                        <div className={styles.line}></div>
                      ) : null
                    }
                  </div>
                  <div className={styles.listR}>
                    <div className={styles.titleW}>
                      <div className={styles.title}>{i?.data?.title}</div>
                      {
                        i?.data?.bbsId || i?.data?.href ? (
                          <div className={styles.view} onClick={() => handleViewDetail(i.data)}>
                            查看详情
                            <img src={rightArrow} alt="" />
                          </div>
                        ) : null
                      }
                    </div>
                    <div className={styles.positionW}>
                      <div className={styles.icon}>
                        <img src={location} alt="" />
                      </div>
                      <div className={styles.position}>{i?.data?.location}</div>
                    </div>
                  </div>
                </div>
              ))
            }
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default ActivitySchedule;
